
const {ExEDConstants} = require('../exed-constants');


const getProductPath = (websiteRoot, locale, formatSlg, pSlg) => {
  return [
    websiteRoot,
    ExEDConstants.PRODUCT_FOLDER_MAP[locale],
    formatSlg,
    pSlg
  ].join('/')
    .replace(/\/\//g, '/');
};


const getNextSession = (p) => {
  let nextSession = null;
  let nextSessionDate = null;
  if(!p || !p.sessions) {
    return null;
  }
  for(const s of p.sessions) {
    if (!s) {
      continue;
    }
    let db = null;
    if(s.site_visibility === false){
      continue;
    }
    try {
      db = Date.parse(s.date_begin);
    } catch {
      // invalid date
    }
    if (db && db >= new Date()) {
      if (nextSession === null) {
        nextSession = s;
        nextSessionDate = db;
      } else {
        if (nextSessionDate > db) {
          nextSessionDate = db;
          nextSession = s;
        }
      }
    }
  }
  return nextSession;
};

const getNextSessionStartDate = (p) => {
  if (p?.sessions) {
    const session = getNextSession(p);
    if (session) {
      return session.date_begin;
    }
  }
  return null;
};


const getNextApplicationDeadline = (product) => {
  if (product?.related_content?.miscellaneous) {
    return product.related_content.miscellaneous.next_deadline;
  }
  return null;
};


const getRelatedProducts = (data, websiteRoot) => {
  if (data?.page?.blocs) {
    for(const b of data.page.blocs) {
      if (b.__typename === 'CmsExEdProductBlocComponentSimilarProducts') {
        let smp = b.similar_products;
        if(smp && smp.length > 0) {
          smp = smp.filter( e => {
            if (e && e.site_visibility !== false) {
              return true;
            }
            return false;
          });
        }
        if (smp && smp.length > 0) {
          return smp.map(p => {
            const nextSession = getNextSession (p);

            return {
              ...p,
              url: getProductPath(websiteRoot, p.locale, p.format.slug, p.slug),
              price : getProductLastSessionPrice(p.sessions),
              nextApplicationDeadline : getNextApplicationDeadline(p),
              nextSessionPlace : nextSession?.place,
              nextSessionDate : nextSession?.date_begin
            };
          });
        }
      }
    }
  }
  return null;
};

const buildContentAction = (array, websiteRoot, locale) => {
  const actions = array.map((e, i) => (
    { ...e,
      icon: (i === 0)? 'CALENDAR' : 'AWARD',
      url: [websiteRoot, ExEDConstants.PRODUCT_FOLDER_MAP[locale], e.slug].join('/').replace(/\/\//g, '/')
    }
  ));
  return actions;
};


const buildArticleUrl = (slug, data, websiteRoot) => {
  return [
    websiteRoot,
    (data?.page?.locale === 'fr') ? 'actualites': 'news',
    slug
  ].join('/')
    .replace(/\/\//g, '/');
};


const getRelatedArticles = (data, websiteRoot) => {
  if (data?.allCmsPortalNewsItem?.nodes) {
    return data.allCmsPortalNewsItem.nodes.map((e) => {
      return {
        ...e,
        url: buildArticleUrl (e.slug, data, websiteRoot)
      };
    });
  }
  return [];
};


const createProductRCBrochureDownloadButton = (rc, rca) => {
  if (rc.miscellaneous?.brochure_url && rc.miscellaneous?.brochure_button_title) {
    rca.push({content: [
      {
        '__typename': 'CmsPortalComponentWidgetActionElement',
        URL: rc.miscellaneous.brochure_url,
        actionColor: 'RED',
        label: rc.miscellaneous.brochure_button_title// t("product.action.element.download")
      }
    ]});
  }
};


const createProductRCActiondButton = (rc, rca) => {
  if (rc.miscellaneous?.action_button_show
      && rc.miscellaneous?.action_button_title && rc.miscellaneous?.action_button_url) {
    rca.push({content: [
      {
        '__typename': 'CmsPortalComponentWidgetActionElement',
        URL: rc.miscellaneous.action_button_url,
        actionColor: 'RED',
        label: rc.miscellaneous.action_button_title// t("product.action.element.download")
      }
    ]});
  }
};


const createProductRCCandidateButton = (rc, rca) => {
  if (rc.miscellaneous?.button_url && rc.miscellaneous?.button_title) {
    rca.push({content: [
      {
        '__typename': 'CmsPortalComponentWidgetActionElement',
        URL: rc.miscellaneous.button_url,
        actionColor: 'BLACK',
        label: rc.miscellaneous.button_title,
      }
    ]});
  }
};


const getProductLastSessionPrice = (sessions) => {
  if (!sessions) return 0;
  let price = 0;
  let dte = 0;
  for(const s of sessions) {
    if(!s) continue;
    if(s.date_begin !== null) {
      const d = Date.parse(s.date_begin);
      if (dte < d) {
        dte = d;
        price = s.price;
      }
    }
  }
  return price;
};


const getRelatedContents = (data) => {
  const rca = [];
  const contacts = data.page?.contacts;
  const rc = data.page?.related_content;


  const sessions = (data.page.sessions || []).filter( s => {
    try {
      return s && s.date_begin && new Date(s.date_begin) >= new Date();
    }catch(e){
      return false;
    }
  });
  sessions.sort((a, b) => {
    const na = new Date(a.date_begin).getTime();
    const nb = new Date(b.date_begin).getTime();
    return na - nb;
  });

  if (rc) {
    createProductRCBrochureDownloadButton(rc, rca);
    createProductRCActiondButton(rc, rca);
    createProductRCCandidateButton(rc, rca);

    const lastSessionPrice = getProductLastSessionPrice(sessions);
    if(!rc.prices) {
      rc.prices = {};
    }
    rc.prices.lastSessionPrice = lastSessionPrice;

    rca.push({
      content: [
        {
          '__typename': 'CmsPortalComponentWidgetProductInfo',
          ...rc,
          sessions: sessions,
          contacts : contacts
        }
      ]
    });
  }
  return rca;
};

module.exports = {
  getRelatedProducts,
  getRelatedArticles,
  getRelatedContents,
  getNextSession,
  buildContentAction,
  getProductLastSessionPrice,
  getProductPath,
  getNextApplicationDeadline,
  getNextSessionStartDate
};
